import React from 'react'
import styled from 'styled-components'
import { ReactComponent as ConfigurationIcon } from '../../../common/assets/images/configuration-icon.svg'
import { ReactComponent as ChangeUserIcon } from '../../../common/assets/icons/change_user_icon.svg'
import { navigateToPath } from '../../../common/Navigation'
import { PagesPathEnum } from '../../../pages/enums/pages-path.enum'
import { gray } from '../../../ui/utils/_colors'
import { PersonUtils } from '../../../utils/person.utils'
import PhoneUtils from '../../../utils/phone.utils'
import { OperatorCenterHelper } from '../../../pages/Operators/OperatorCenterHelper'
import { useTypedSelector } from '../../../redux/reducers/selectors'
import { useDispatch } from 'react-redux'
import OperatorServiceCenterSliceReducer from '../../../redux/reducers/operator-service-center/operator-service-center.reducer'

export interface OperatorHeaderProps {
  operatorName?: string
  operatorPhoneNumber?: string
  storeName?: string
}

const OperatorHeader: React.FC<OperatorHeaderProps> = props => {
  const dispatch = useDispatch()
  const { operatorName, operatorPhoneNumber, storeName } = props

  const configurations = useTypedSelector(state => state.configurations.configurations)

  const handleGoOperatorConfiguration = () => {
    navigateToPath(PagesPathEnum.OPERATOR_CONFIGURATION)
  }
  const handleChangeOperator = () => {
    dispatch(OperatorServiceCenterSliceReducer.actions.resetRequest())
    navigateToPath(PagesPathEnum.OPERATOR_SERVICE_CENTER)
  }

  const shouldDisableOperatorEdition = OperatorCenterHelper.shouldDisableOperatorEdition(configurations)
  const isStoreLogin = OperatorCenterHelper.isStoreLogin(configurations)
  return (
    <MainContainer>
      <RowContainer>
        <OperatorInfoContainer>
          <Title>Olá, {PersonUtils.getFirstName(operatorName)}.</Title>
          <OperatorInfo color={gray.scale300}>{PhoneUtils.maskPhone(operatorPhoneNumber)}</OperatorInfo>
          <OperatorInfo color={gray.scale400}>{storeName}</OperatorInfo>
        </OperatorInfoContainer>

        <OperatorConfigButtonsSection>
          {!shouldDisableOperatorEdition && (
            <OperatorConfigButton onClick={handleGoOperatorConfiguration}>
              <ConfigurationIcon />
            </OperatorConfigButton>
          )}

          {isStoreLogin && (
            <OperatorConfigButton onClick={handleChangeOperator}>
              <ChangeUserIcon />
            </OperatorConfigButton>
          )}
        </OperatorConfigButtonsSection>
      </RowContainer>
    </MainContainer>
  )
}

export default OperatorHeader

interface OperatorInfoProps {
  color: string
}

const MainContainer = styled.div`
  width: 100%;
  height: auto;
  background: ${gray.grayishBlue};
`

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 0 16px;
`

const OperatorInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: auto;
  margin: 12px 0;
`

const Title = styled.text`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  color: white;
`

const OperatorInfo = styled.text`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: ${(props: OperatorInfoProps) => props.color};
  letter-spacing: 0.001em;
  padding-top: 4px;
`

const OperatorConfigButtonsSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`

const OperatorConfigButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: auto;
  height: 40px;

  border-radius: 100%;

  cursor: pointer;

  &:hover {
    svg rect {
      fill: ${gray.scale200};
    }
  }
`
